const mixpanel = window.mixpanel || null;

export default store => next => action => {
    if (!mixpanel || !action.tracker) {
        return next(action);
    }

    const { eventName, eventProperties } = action.tracker;
    if (!eventName || eventName.trim().length === 0) {
        console.warn("No event name given while attempting to track an event");
        return next(action);
    }

    const properties = {};

    const state = store.getState();
    const user = state.entities.users[state.session.userId];

    if (user) {
        mixpanel.identify(user.id);
        mixpanel.people.set({
            $email: user.emailAddress,
            $created: user.dateCreated,
            $last_login: new Date(),
            $first_name: user.firstName,
            $last_name: user.lastName,
            teams: user.teams.map(t => {
                return {
                    name: t.name,
                    slug: t.slug,
                    dateCreated: t.dateCreated
                };
            }),
            team_ids: user.teams.map(t => t.id).join(", "),
            team_names: user.teams.map(t => t.name).join(", ")
        });
        properties.distinct_id = user.id;
    }

    mixpanel.track(eventName, {
        ...properties,
        ...eventProperties
    });

    return next(action);
};



// WEBPACK FOOTER //
// ./src/store/tracker.js